export function findKenyaCountry(countries = []) {
  return (
    countries.find((c) => {
      const name = String(c.countryName || "").trim().toLowerCase();
      const code = String(c.countryCode || "").trim().toUpperCase();
      return name === "kenya" || code === "KE" || code === "KEN";
    }) || null
  );
}
